// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2xjrl","imageUploader":"EGiftCard_imageUploader__1rOEF"};